module.exports = __webpack_public_path__ + "static/media/loan-banner.cc621eb7.jpg";